import http from './http';

/**
 * Check if the argument passed is a boolean
 *
 * @param {*} element
 * @returns {bool}
 */
export const isBoolean = element => typeof element === 'boolean';

/**
 * Check if the argument passed is an object
 *
 * @param {*} element
 * @returns {boolean}
 */
export const isObject = element => typeof element === 'object' && element !== null;

/**
 * Check if the argument passed is an array
 *
 * @param {*} element
 * @returns {boolean}
 */
export const isArray = element => Array.isArray(element);

/**
 * Check if the argument passed is a string
 *
 * @param {*} element
 * @returns {boolean}
 */
export const isString = element => typeof element === 'string' || element instanceof String;

/**
 * Check if the argument passed is a string
 *
 * @param {*} element
 * @returns {boolean}
 */
export const isNumber = element => typeof element === 'number' || element instanceof Number;

/**
 * Check if the argument passed is a null
 *
 * @param {*} element
 * @returns {boolean}
 */
export const isNull = element => element === null;

/**
 * Check if the argument passed is a empty object
 *
 * @param {object} obj
 * @returns {boolean}
 */
export const isEmptyObject = obj => Object.entries(obj).length === 0;

export class PersonalDataValidator {
  validateRemotely = async (validatorName, payload) => {
    const result = await http.patch(`/validators/${validatorName}`, {
      payload,
    });

    return result.data;
  };

  isValid = async (validatorName, payload) => {
    const data = await this.validateRemotely(validatorName, payload);
    return !!data.valid;
  };

  nip = async payload => this.isValid('nip', payload);

  nipDetails = async payload => this.validateRemotely('nip', payload);

  street = async payload => this.isValid('street', payload);

  streetDetails = async payload => this.validateRemotely('street', payload);

  postalCode = async payload => this.isValid('postalcode', payload);

  socialMediaUrl = async payload => this.isValid('socialmedia', payload);

  fullname = async payload => this.isValid('fullname', payload);

  fullnameDetails = async payload => this.validateRemotely('fullname', payload);

  bankNumber = async payload => this.isValid('banknumber', payload);

  lookupNip = async nip => {
    const result = await http.post('/validators/lookup/nip', { nip });
    return result.data;
  };

  lookupAddress = async ({
    input,
    sessionToken = '',
    country = 'PL',
    type = 'street',
    postalCode = '',
    city = '',
    street = '',
  }) => {
    const result = await http.post('/validators/lookup/address', {
      input,
      sessionToken,
      country,
      type,
      postalCode,
      city,
      street,
    });
    return result.data;
  };

  lookupAddressDetails = async ({ placeId, sessionToken = '' }) => {
    const result = await http.post('/validators/lookup/address/details', {
      placeId,
      sessionToken,
    });
    return result.data;
  };
}
